import { call, put, all } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getEventList(action: any): any {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GET_EVENT_LIST, action.payload, false, yieldPuts);
}

export function* getPastEventList(action: any): any {
  const yieldPuts: any = [
    // { type: ACTIONS.EVENT.GET_EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GET_PAST_EVENT_LIST, action.payload, false, yieldPuts);
}

export function* getChallengeList(action: any): any {
  const yieldPuts: any = [
    // { type: ACTIONS.EVENT.GET_EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.CHALLENGE_LIST, action.payload, true, yieldPuts);
}

export function* getChallengeDetails(action: any): any {
  const yieldPuts: any = [
    // { type: ACTIONS.EVENT.EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.CHALLENGE_DETAILS, action.payload, true, yieldPuts);
}

export function* createChallenge(action: any): any {
  const yieldPuts: any = [
    // { type: ACTIONS.EVENT.EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.CREATE_CHALLENGE, action.payload, true, yieldPuts);
}

export function* joinChallenge(action: any): any {
  const yieldPuts: any = [
    // { type: ACTIONS.EVENT.EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.CHALLENGE_JOIN, action.payload, true, yieldPuts);
}

export function* withdrawChallenge(action: any): any {
  const yieldPuts: any = [
    // { type: ACTIONS.EVENT.EVENT_LIST },
    // {type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED},
  ];
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.CHALLENGE_WITHDRAW, action.payload, true, yieldPuts);
}

export function* getEventGameList(action: any): any {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_EVENT_GAME, payload: "event_dtls" },
    { type: ACTIONS.EVENT.GET_STATUS_MESSAGE, payload: "status" },
    { type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED, payload: "rodeo_event_dtls.login_required" },
    { type: ACTIONS.EVENT.SITE_HEADER, payload: "rodeo_event_game_info.enable_header" },
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GET_EVENT_GAME, action.payload, true, yieldPuts);
}

export function* performanceList(action: any): any {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_PERFORMANCE_LIST, payload: "performances" },
    { type: ACTIONS.EVENT.GET_STATUS_MESSAGE, payload: "status" },
    { type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED, payload: "rodeo_event_dtls.login_required" },
    { type: ACTIONS.EVENT.SITE_HEADER, payload: "rodeo_event_game_info.enable_header" },
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.PERFORMANCE_LIST, action.payload, true, yieldPuts);
}

export function* getEventGameDetails(action: any): any {
  const yieldPuts = [
    { type: ACTIONS.EVENT.GET_EVENT_GAME_DETAILS },
    { type: ACTIONS.EVENT.GET_STATUS_MESSAGE, payload: "status" },
    { type: ACTIONS.EVENT.RODEO_EVENT_LOGIN_REQUIRED, payload: "rodeo_event_dtls.login_required" },
    { type: ACTIONS.EVENT.SITE_HEADER, payload: "rodeo_event_game_info.enable_header" },
  ];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GET_EVENT_GAME_DETAILS, action.payload, true, yieldPuts);
}

export function* getUpcomingEventList(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.GET_UPCOMING_EVENT, action.payload, false);
}

export function* joinEventGame(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.JOIN_EVENT_GAME, action.payload, true);
}

// export function* pickRider(action: any): any {
//   const yieldPuts = [{ type: ACTIONS.EVENT.SET_PICK_ID, payload: "id" }, { type: ACTIONS.EVENT.SET_EVENT_IS_PICKED }];
//   yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.PICK_RIDER, action.payload, true, yieldPuts);
// }

export function* viewLeaderBoard(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.LEADERBOARD, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      yield put({
        type: ACTIONS.EVENT.LEADERBOARD,
        payload: resp.data.data,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* tvImageDetails(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.TV_IMAGE.DETAILS, data);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      yield put({
        type: ACTIONS.TV_IMAGE.DETAILS,
        payload: resp.data.data,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* saveVote(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.EVENT.SAVE_VOTE, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getGameDetails(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.GET_GAME_DETAILS, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      yield put({
        type: ACTIONS.EVENT.GET_GAME_DETAILS,
        payload: resp.data.data,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getPrizeDetails(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.PRIZE, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getRodeoEventGeoLocations(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      // yield put({
      //     type: ACTIONS.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS,
      //     payload: resp.data.data
      // })

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getLeaderboardLocationList(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.LEADERBOARD_LOCATION_LIST, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      // yield put({
      //     type: ACTIONS.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS,
      //     payload: resp.data.data
      // })

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* winningTicketResults(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.WINNING_TICKET_RESULTS, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* mostPopularPicks(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.EVENT.MOST_POPULAR_PICKS, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* saveLeagueCode(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.SAVE_LEAGUE_CODE, action.payload, true);
}

export function* getLeagueLeaderboard(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.LEAGUE_LEADERBOARD, action.payload, false);
}

export function* getVsLeagueLeaderboard(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.VS_LEAGUE_LEADERBOARD, action.payload, false);
}

export function* getMyTeam(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.GET_MY_TEAM, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getShareImageLink(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.EVENT.SHARE_IMAGE_LINK, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* yourPicks(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.YOUR_PICKS, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getGameStatusText(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URL.EVENT.GET_GAME_STATUS_TEXT + (data?.game_id ? "/" + data?.game_id : "")
    );
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      console.log({ resp });
      yield put({
        type: ACTIONS.EVENT.GET_IR_STATUS_MESSAGE,
        payload: resp.data.data,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getGallery(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GET_GALLERY, action.payload, false);
}

export function* saveTieBreakerCode(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.SAVE_TIEBREAKER_CODE, action.payload, true);
}

export function* pickOption(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.EVENT.PICK_OPTION, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      yield put({
        type: ACTIONS.EVENT.SET_PICK_ID,
        payload: resp.data.data.id,
      });
      yield put({
        type: ACTIONS.EVENT.SET_EVENT_IS_PICKED,
        payload: resp.data.data,
      });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
